import { useFrame } from "@react-three/fiber";
import { useRef } from "react";
import * as THREE from "three";
import type { ProjectionParams } from "../config/types";
import {
  calculateObliqueMatrix,
  applyObliqueProjection,
} from "../utils/projection";

// 기본 오프셋 캐시 (매 프레임 new Vector3 방지)
const DEFAULT_OFFSET = new THREE.Vector3(0, 0, 0);

/**
 * Oblique 투영을 적용하는 훅
 * 매 프레임마다 그룹에 Oblique 행렬을 적용
 * 
 * 최적화: panOffset이 변경되지 않으면 캐싱된 calculateObliqueMatrix 결과 사용
 */
export function useObliqueProjection(
  groupRef: React.RefObject<THREE.Group>,
  params: ProjectionParams,
  getPanOffset?: () => THREE.Vector3,
) {
  const prevPanOffsetRef = useRef<THREE.Vector3>(new THREE.Vector3());
  
  useFrame(() => {
    if (groupRef.current) {
      const panOffset = getPanOffset ? getPanOffset() : DEFAULT_OFFSET;
      
      // panOffset 변경 체크 - 변경되지 않았으면 calculateObliqueMatrix가 캐시 반환
      // (projection.ts의 캐싱 시스템이 자동으로 처리)
      const matrix = calculateObliqueMatrix(params, panOffset);
      applyObliqueProjection(groupRef.current, matrix);
      
      prevPanOffsetRef.current.copy(panOffset);
    }
  });
}
